import React from "react";
import { NoShowReportList } from "./NoShowReportList";

export function NoShowReportListContainer() {
  return <NoShowReportList />;
}

